import _ from '../../utils/underscore';

class ExtendableError {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExtendableError';


    /**
     *
     * @returns {ExtendableError}
     */
    static create() {
        let $instance = new this(); // constructor SHOULD NOT GET ANYTHING... it's TEMPORARY HERE!
        if (_.isFunction($instance.init)) {
            $instance.init.apply($instance, arguments);
        }

        return $instance;
    }

    /**
     * Initialized extendable error
     * @param exceptionParams
     */
    init(exceptionParams) {
        this.name = exceptionParams.name;
        this.message = exceptionParams.message | '';
        this.error_code = exceptionParams.error_code;
        this.error_description = exceptionParams.error_description;
        this.lineNumber = exceptionParams.lineNumber;
        this.fileName = exceptionParams.fileName;
        this.model = exceptionParams.model;
    }


    /**
     *
     * @returns {Window.onerror}
     */
    onError() {
        return window.onerror = (errorMsg, url, lineNumber, column, errorObj) => {
            console.log('Global Exception Handler');
            if (errorMsg.indexOf('Script error.') > -1) {
                return;
            }
        }
    }
}

export default ExtendableError;